var _circle, _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmsUnread(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#71767C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3545 10.876H17.1729V21H15.0059V13.7607C14.6686 13.9385 14.2448 14.0798 13.7344 14.1846C13.224 14.2848 12.7044 14.335 12.1758 14.335L11.957 13.0771C12.873 12.9222 13.5931 12.6761 14.1172 12.3389C14.6504 11.9925 15.0628 11.5049 15.3545 10.876Z",
    fill: "#71767C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 8,
    height: 8,
    rx: 4,
    fill: "#ED0007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmsUnread);
export default __webpack_public_path__ + "static/media/dms-unread.420813a1284025dae60ebaceb285ee04.svg";
export { ForwardRef as ReactComponent };